import { logger } from './logger';

/**
 * In the development environment, automatically prepends "[dev]" to the document title.
 * Uses a MutationObserver on <head> to ensure that any updates to the document title (e.g. from React 19 title hoisting
 * or other dynamic title changes) are always prefixed with "[dev]".
 */
export function initDevTitle() {
  if (typeof window === 'undefined') return;

  const isDev = import.meta.env.VITE_APP_ENV === 'dev';
  if (!isDev) return;

  const head = document.querySelector('head');
  if (!head) {
    logger.warn('Failed to find <head> element to initialize dev title observer');
    return;
  }

  const prefix = '[dev] ';

  const updateTitle = () => {
    if (document.title && !document.title.startsWith(prefix)) {
      document.title = `${prefix}${document.title}`;
    }
  };

  const observer = new MutationObserver(() => {
    updateTitle();
  });

  observer.observe(head, {
    subtree: true,
    characterData: true,
    childList: true,
  });

  // Run immediately for initial page load
  updateTitle();
}
